import { TitleH4 } from "@/components/shared/public";
import { Card, CardFooter, CardHeader } from "@/components/ui/card";
import Image from "next/image";
import { ComponentProps } from "react";

type ExampleCardProps = ComponentProps<typeof Image> &
  ComponentProps<typeof TitleH4> & {
    description: string;
  };

const ExampleCard = ({ ...props }: ExampleCardProps) => {
  return (
    <Card className="h-full w-[280px]">
      <CardHeader className="p-1">
        <div className="flex w-full items-center justify-center">
          <Image
            src={props.src}
            alt={props.alt}
            width={230}
            className="h-auto"
          />
        </div>
      </CardHeader>
      <CardFooter className="flex flex-col items-center gap-2 p-5">
        <span className="text-primary text-2xl font-normal">
          {props.title}{" "}
        </span>
        <span className="text-ring">{props.description}</span>
      </CardFooter>
    </Card>
  );
};

export default ExampleCard;
